import { render, staticRenderFns } from "./DetailNews.vue?vue&type=template&id=4dc7df26&scoped=true"
import script from "./DetailNews.vue?vue&type=script&lang=js"
export * from "./DetailNews.vue?vue&type=script&lang=js"
import style0 from "./DetailNews.vue?vue&type=style&index=0&id=4dc7df26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7df26",
  null
  
)

export default component.exports